// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"relatedBreeds_wrapper__U0sJR","grid_images":"relatedBreeds_grid_images__MDubl","link_image":"relatedBreeds_link_image__5I2vq","image":"relatedBreeds_image__zdpBb"};